import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m35.78 33.305-7.587-7.587a.742.742 0 0 0-.532-.22h-.825A12.964 12.964 0 0 0 30 17C29.999 9.82 24.18 4 16.999 4 9.82 4 4 9.818 4 17c0 7.18 5.818 12.999 13 12.999 3.25 0 6.218-1.194 8.499-3.163v.825c0 .2.081.388.219.532l7.587 7.587a.75.75 0 0 0 1.062 0l1.413-1.413a.75.75 0 0 0 0-1.062ZM17 26.999c-5.525 0-10-4.475-10-10 0-5.524 4.475-10 10-10 5.524 0 9.999 4.476 9.999 10 0 5.525-4.475 10-10 10Z" })
});
export default SvgSearch;
